import React, { useState } from "react";
import { Link, NavLink } from "react-router-dom";

import "./Navbar.css";

const Navbar = ({ user }) => {
  const [isOpen, toggleMenu] = useState(false);

  const closeNav = () => {
    toggleMenu(false);
  };
  return (
    <>
      <div className="toggle-nav" onClick={() => toggleMenu(true)}>
        <span className="menu-humb"></span>
        <span className="menu-humb"></span>
        <span className="menu-humb"></span>
      </div>
      <div className={isOpen ? "navbar__header open" : "navbar__header close"}>
        <div className="close-nav" onClick={() => toggleMenu(false)}>
          <span>x</span>
        </div>
        <div className="nav__content">
          <nav className="nav">
            <h1>
              <Link className="link logo" to="/">
                FOODDY
              </Link>
            </h1>

            <ul className="nav__list">
              <li onClick={closeNav} className="nav__item">
                <NavLink className="nav__link link" to="/">
                  Home
                </NavLink>
              </li>
              <li onClick={closeNav} className="nav__item">
                <NavLink className="nav__link link" to="/foods">
                  Foods
                </NavLink>
              </li>

              <li onClick={closeNav} className="nav__item">
                <NavLink className="nav__link link" to="/about">
                  About
                </NavLink>
              </li>
              <li onClick={closeNav} className="nav__item">
                <NavLink className="nav__link link" to="/developer">
                  Developer
                </NavLink>
              </li>
            </ul>
          </nav>

          {user && (
            <div className="header__button">
              {user && user.isAdmin ? (
                <Link
                  onClick={closeNav}
                  to="/dashborad"
                  className="m-r-s btn btn-signup link"
                >
                  Dashboard
                </Link>
              ) : null}
              <Link
                onClick={closeNav}
                to="/profile"
                className="btn m-r-s btn-login link"
              >
                {user.name}
              </Link>
              <Link to="/logout" className="btn btn-signup link">
                Logout
              </Link>
            </div>
          )}

          {!user && (
            <div className="header__links">
              <Link
                onClick={closeNav}
                to="/signup"
                className="btn btn-signup link m-r-s"
              >
                Signup
              </Link>

              <Link
                onClick={closeNav}
                to="/login"
                className="btn btn-login link"
              >
                Login
              </Link>
            </div>
          )}
        </div>
      </div>
    </>
  );
};

export default Navbar;
